import { ROLES } from '../constants/roles';

const useRolesList = (accountRole, entitiesLength, withDescription = false) => {
  return Object.values(ROLES)
    .filter((role) => {
      if (accountRole === ROLES.org_admin.value) {
        return entitiesLength === 1 ? role.value !== 'ent_admin' : true;
      }
      return role.value !== 'org_admin';
    })
    .map((role) => ({
      label: role.label,
      value: role.value,
      description: withDescription ? role.description : null,
    }));
};

export default useRolesList;
